import { coreApi } from "./coreApi";

export const IncomeStatementApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getIncomeStatement: builder.query({
      query: (queryString) => `/accounting/reports/income-statement?${queryString}`,
    }),
  }),
});

export const { useGetIncomeStatementQuery, useLazyGetIncomeStatementQuery } = IncomeStatementApi;

export default IncomeStatementApi;
